import { render } from "./RealtorsOverviewView.vue?vue&type=template&id=b3b9ce4a&ts=true"
import script from "./RealtorsOverviewView.vue?vue&type=script&lang=ts"
export * from "./RealtorsOverviewView.vue?vue&type=script&lang=ts"

import "./RealtorsOverviewView.vue?vue&type=style&index=0&id=b3b9ce4a&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__